import { render, staticRenderFns } from "./nomalHelpDoc.vue?vue&type=template&id=382a1ece&scoped=true&"
import script from "./nomalHelpDoc.vue?vue&type=script&lang=js&"
export * from "./nomalHelpDoc.vue?vue&type=script&lang=js&"
import style0 from "./nomalHelpDoc.vue?vue&type=style&index=0&id=382a1ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382a1ece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('382a1ece')) {
      api.createRecord('382a1ece', component.options)
    } else {
      api.reload('382a1ece', component.options)
    }
    module.hot.accept("./nomalHelpDoc.vue?vue&type=template&id=382a1ece&scoped=true&", function () {
      api.rerender('382a1ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/helpDoc/nomalHelpDoc.vue"
export default component.exports